export const environment = {
  production: true,
  hmr: false,
  API_URL: 'https://apipruebas.nubyy.com/api',
  WEBSOCKET_URL: 'https://apipruebas.nubyy.com/',
  CEDULAS_URL: 'https://busquedacedulas.nubyy.com/api',
  MERCURE_URL: 'https://mercure.nubyy.com/.well-known/mercure',
  IDEMPIER_GATEWAY: 'https://www.idempier.com:8200/api',
  KEYCLOAK_REALM:
    'https://www.idempier.com:8443/realms/codi-microservices-realm/protocol/openid-connect/token',
  CLIENT_ID: 'web-cli',
  CLIENT_SECRET: 'nFd6hyP8CQzI9MKyJXUoU8myEicNVC68',
  KEYCLOAK_USERNAME: 'idempierweb',
  KEYCLOAK_PASSWORD: 'TyEf#618',
  KEYCLOAK_USERS_ENDPOINT:
    'https://www.idempier.com:8443/admin/realms/codi-microservices-realm/users',
  BASE_LINK: 'https://www.idempier.com',
  REDIRECT_LINK: 'com.idempierapp://localhost',
};
